"use client";

import React, { createContext, useContext, useState, useEffect } from "react";
import { usePathname } from "next/navigation";

interface HeaderContextType {
  showNavLinks: boolean;
  setShowNavLinks: (val: boolean) => void;
  showLocationDropdown: boolean;
  setShowLocationDropdown: (val: boolean) => void;
  showUser: boolean;
  setShowUser: (val: boolean) => void;
  showCart: boolean;
  setShowCart: (val: boolean) => void;
  showSearch: boolean;
  setShowSearch: (val: boolean) => void;
  isAppLaunched: boolean;
  setIsAppLaunched: (val: boolean) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const pathname = usePathname();
  
  const [showNavLinks, setShowNavLinks] = useState(true);
  const [showLocationDropdown, setShowLocationDropdown] = useState(true);
  const [showUser, setShowUser] = useState(true);
  const [showCart, setShowCart] = useState(true);
  const [showSearch, setShowSearch] = useState(true);
  const [isAppLaunched, setIsAppLaunched] = useState(true);

  return (
    <HeaderContext.Provider
      value={{
        showNavLinks,
        setShowNavLinks,
        showLocationDropdown,
        setShowLocationDropdown,
        showUser,
        setShowUser,
        showCart,
        setShowCart,
        showSearch,
        setShowSearch,
        isAppLaunched,
        setIsAppLaunched,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    return {
      showNavLinks: true,
      setShowNavLinks: () => {},
      showLocationDropdown: true,
      setShowLocationDropdown: () => {},
      showUser: true,
      setShowUser: () => {},
      showCart: true,
      setShowCart: () => {},
      showSearch: true,
      setShowSearch: () => {},
      isAppLaunched: true,
      setIsAppLaunched: () => {},
    };
  }
  return context;
};
